var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1007,
    height: 890,
    viewBox: "0 0 1007 890",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50001 295.5C6.50001 295.5 56.4999 144.072 174 144.072C306.388 144.072 344.06 -36.5181 468.486 8.07231C602.601 56.1349 582.217 111.919 721.157 144.072C820.17 166.986 878.772 4.30561 1006.5 37.9596C1006.5 37.9596 1006.5 280.842 1006.5 453.655C1006.5 608.155 1006.5 684.47 1006.5 684.47V881.173C904.969 916.684 828.147 829.828 721.157 817.239C566.497 799.041 548.658 860 393 860C249 860 119 779.388 119 645.5C119 395 -29.4999 478.5 6.50001 295.5Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 112.755,
    y1: 456.651,
    x2: 1097.26,
    y2: 1137.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D99A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CD06E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBox);
export default __webpack_public_path__ + "static/media/rightBox.d21ae1339f9aa4e4df0aff9b0ae05324.svg";
export { ForwardRef as ReactComponent };